window.detailPage = function() {
    const shareLink = () => {
        window.setShareLinks();
    };
    
    const calendar = () => {
        window.addToCalendar = function(id, status) {
            $.ajax({
                type: "POST",
                url: HOST_URL + '/events/calendar/' + id,
                data: {
                    status: status
                }
            })
            .done(function(response) {
                $('#event-calendar').html(response);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                if(403 == xhr.status) {
                    window.location.href = HOST_URL + '/email/verify';
                }
            });
        }
    }

    return {
        init: function() {
            shareLink();
            calendar();
        }
    };
}();